import { Injectable } from "@angular/core";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { map, Observable } from "rxjs";
import { Disbursment, DisbursmentDetails } from "src/app/modules/Disbursment_modules/disbursment/disbursment.component.model";

@Injectable({
    providedIn: "root"
})
export class DisbursementService {


    constructor(private http: CommonHttpModule) { }


    // method to get the data from db
    getDisbursementData(params: any): Observable<{ data: Disbursment[]; total_count: number }> {
        return this.http.post<{ total_count: number, data: Disbursment[] }>("disbursement_tracker", params)
            .pipe(
                map(response => ({
                    total_count: response.total_count,
                    data: response.data
                }))
            );
    }

    // method to get the disbursement data based on client
    getClientDisbursementData(params: any): Observable<{ data: Disbursment[]; total_count: number }> {
        return this.http.post<{ total_count: number, data: Disbursment[] }>("client_disbursement_tracker", params)
            .pipe(
                map(response => ({
                    total_count: response.total_count,
                    data: response.data
                }))
            );
    }



    // method to get the disbursementDtl from db

    getDisbursementDataDtls(params: any): Observable<{ data: DisbursmentDetails }> {
        return this.http.get<{ data: DisbursmentDetails }>(`disbursement_tracker_detail/${params}`, {})
            .pipe(
                map((response) => {
                    return response;
                })
            );
    }


    // method to send the data to db
    disbursementDataToDb(disbursementDlts: DisbursmentDetails): Observable<any> {
        return this.http.post("disbursement_tracker_update", disbursementDlts).pipe(
            map((response) => {
                return response;
            })
        )
    }
    getDisbursementDataToExport(params: any): Observable<DisbursmentDetails[]> {
        return this.http.post<any>(
            "export_disbursement_detail",
            params
        ).pipe(
            map(response => {
                return response;
            })
        );
    }

    deleteOrInActivateDisbursement(params: any): Observable<any> {
        return this.http.post(`active_inactive_delete_state`, params).pipe(
            map((response) => {
                return response;
            })
        )
    }

    paymentInstructionEmail(data: any): Observable<any> {
        return this.http.post(`payment_instruction_mail`, data).pipe(
            map((response) => {
                return response;
            })
        )
    }


    updateDashboardRow(request: any): Observable<any> {
  return this.http.post(
    'dashboard-table/update-row',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}


raiseDispute(request: any): Observable<any> {
  return this.http.post(
    'client_comment',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}

}